import React from "react";
import { Link } from "react-router-dom";

/**
 * Footer auto-adapta-se ao tema:
 * - Em páginas dark (default): usa cores escuras existentes.
 * - Quando dentro de `.alvorada` wrapper: usa tons quentes (via CSS).
 */
const Footer = () => (
  <footer
    className="alv-footer border-t border-white/5 py-10 mt-16 text-sm text-[#A29F9B]"
    data-testid="app-footer"
  >
    <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row gap-4 md:items-center md:justify-between">
      <div>© {new Date().getFullYear()} Solfut, Lda</div>
      <nav className="flex items-center gap-5 flex-wrap">
        <Link to="/artigos" className="hover:text-[#C5A880] transition-colors" data-testid="footer-articles">Artigos</Link>
        <Link to="/termos" className="hover:text-[#C5A880] transition-colors" data-testid="footer-terms">Termos e Condições</Link>
        <Link to="/reembolsos" className="hover:text-[#C5A880] transition-colors" data-testid="footer-refunds">Reembolsos</Link>
        <Link to="/privacidade" className="hover:text-[#C5A880] transition-colors" data-testid="footer-privacy">Privacidade</Link>
        <Link to="/contacto" className="hover:text-[#C5A880] transition-colors" data-testid="footer-contact">Contacto</Link>
      </nav>
    </div>
  </footer>
);

export default Footer;
